import map from "lodash/map";
import { useActivityShortlists } from "PFApp/activities/show/hooks/use_activity_shortlists";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { AddActivityProfilesModalContent } from "PFApp/activities/show/parts/activity_profiles/add_activity_profiles_modal_content";
import { getGrowlId, useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Modal } from "PFComponents/modal";
import { useShortlistCreate } from "PFCore/hooks/queries/shortlists/use_shortlist_create";
import { Profile } from "PFTypes";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ADD_SHORTLIST_SUCCESS_ACTION_ID = getGrowlId("add-shortlist");

type AddShortlistModalProps = {
  onClose: VoidFunction;
};

export const AddShortlistModal = ({ onClose }: AddShortlistModalProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.shortlist.addShortlistModal" });
  const { showGrowl } = useGrowlStoreActions();

  const activity = useCurrentActivity();
  const { allShortlists } = useActivityShortlists();
  const { mutateAsync: createShortlist } = useShortlistCreate();

  const [profiles, setProfiles] = useState<Profile[]>([]);
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    if (isSaving) {
      return;
    }

    setIsSaving(true);

    const shortlistCreators = map(profiles, ({ id: profileId }) =>
      createShortlist({ activityId: activity.id, profileId, named: true })
    );

    await Promise.all(shortlistCreators)
      .then(() => {
        showGrowl({
          id: ADD_SHORTLIST_SUCCESS_ACTION_ID,
          kind: "success",
          message: t("successMessage"),
          hidePreviousByTypeAndId: true,
          ttl: 10000
        });
      })
      .catch(() => {
        showGrowl({ message: t("failedMessage"), kind: "error" });
      });

    setIsSaving(false);
  };

  return (
    <Modal
      disableOKButton={profiles.length === 0}
      title={t("title")}
      labelOK={t("addToShortlist")}
      onOK={handleSubmit}
      onClose={onClose}
    >
      <AddActivityProfilesModalContent
        newProfiles={profiles}
        onNewProfilesChange={setProfiles}
        profiles={[]}
        disabledProfileIds={allShortlists.map(({ profile }) => profile.id)}
        activity={activity}
      />
    </Modal>
  );
};
